<template>
  <div class="budget-bid-wrap">
    <div class="card-header">
      预算与出价<span class="num-text">{{ dataList.length }}/10</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" @click="newBudgetbid"
          >新建</el-button
        ><span class="center-line"></span>
        <el-button icon="el-icon-plus" type="text" @click="selectBudgetBid"
          >选择已有</el-button
        >
      </div>
    </div>
    <div class="card-list">
      <card-item
        v-for="item of dataList"
        :key="item.itemId"
        :dataSet="item"
        @edit="editBudget"
        @copy="copyBudget"
        @del="delBudget"
        :isCur="curFormData.itemId === item.itemId"
        :showDelete="dataList.length > 1"
      ></card-item>
    </div>
    <div class="modal-body">
      <ul class="modal-form">
        <el-form :model="curFormData" :rules="rules" ref="formRef">
          <li class="form-item">
            <span class="form-label">投放时间：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.schedule_type">
                <el-radio label="SCHEDULE_FROM_NOW">从今天到长期投放</el-radio>
                <el-radio label="SCHEDULE_START_END"
                  >设置开始和结束日期</el-radio
                >
              </el-radio-group>
              <div v-show="curFormData.schedule_type === 'SCHEDULE_START_END'">
                <el-date-picker
                  class="data-range"
                  v-model="curFormData.selectDate"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 265px"
                  :clearable="false"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">广告组预算：</span>
            <div class="form-value">
              <el-radio-group
                v-model="curFormData.budget_mode"
                @change="renderRule()"
              >
                <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                <el-radio label="BUDGET_MODE_DAY">统一预算</el-radio>
                <el-radio label="BUDGET_MODE_DAY_SCHEDULE">分日预算</el-radio>
              </el-radio-group>
              <div
                style="margin-top: 10px"
                v-if="curFormData.budget_mode !== 'BUDGET_MODE_INFINITE'"
              >
                <el-form-item
                  v-if="curFormData.budget_mode === 'BUDGET_MODE_DAY'"
                  style="margin-bottom: 0px"
                  prop="day_budget"
                >
                  <el-input
                    style="width: 264px"
                    v-model.trim="curFormData.day_budget"
                    placeholder="不小于100，不超过100000000的自然数"
                  >
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-else prop="weekData">
                  <ul class="week-wrap">
                    <li
                      class="week-item"
                      v-for="item of curFormData.weekData"
                      :key="item.lable"
                    >
                      <div class="week-label">{{ item.lable }}</div>
                      <div class="week-value">
                        <input
                          class="week-input"
                          v-model="item.value"
                          type="text"
                          placeholder=""
                          @input="renderRule()"
                        />
                      </div>
                    </li>
                  </ul>
                </el-form-item>
              </div>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">投放时间段：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.schedule_time_type">
                <el-radio label="0">全天</el-radio>
                <el-radio label="1">特定时间</el-radio>
              </el-radio-group>
              <div
                class="time-range-wrap"
                v-show="curFormData.schedule_time_type === '1'"
              >
                <time-table ref="timeTableRef"></time-table>
              </div>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">创意展现方式：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.show_mode">
                <el-radio :label="2">智能优选</el-radio>
                <el-radio :label="1">随机轮播</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">优化目标：</span>
            <div class="form-value">
              <el-radio-group
                v-model="curFormData.ocpx_action_type"
                @change="changeActionType"
              >
                <el-radio :label="1">封面点击数</el-radio>
                <el-radio :label="2">行为数</el-radio>
                <el-radio :label="180">激活数</el-radio>
                <el-radio :label="773">关键行为</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-if="curFormData.ocpx_action_type === 180">
            <span class="form-label">深度转化目标：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.deep_conversion_type">
                <el-radio :label="0">无</el-radio>
                <el-radio :label="7">次日留存</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">计费方式：</span>
            <div class="form-value">
              <el-radio-group v-model="curFormData.bid_type">
                <el-radio :label="2" v-show="curFormData.bid_type === 2"
                  >点击(CPC)</el-radio
                >
                <el-radio :label="10" v-show="curFormData.bid_type === 10"
                  >曝光计费(oCPM)</el-radio
                >
              </el-radio-group>
            </div>
          </li>
          <!-- <li
            v-if="curFormData.ocpx_action_type === 191"
            class="form-item"
            style="margin-bottom: 0px"
          >
            <span class="form-label require" style="padding-top: 6px"
              >ROI系数：</span
            >
            <div class="form-value">
              <el-form-item prop="roi_ratio">
                <el-input
                  style="width: 264px"
                  v-model.trim="curFormData.roi_ratio"
                >
                </el-input>
              </el-form-item>
            </div>
          </li> -->
          <li class="form-item" style="margin-bottom: 0px">
            <span class="form-label require" style="padding-top: 6px"
              >出价：</span
            >
            <div class="form-value">
              <el-form-item prop="cpa_bid">
                <el-input
                  style="width: 264px"
                  v-model.trim="curFormData.cpa_bid"
                >
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>
            </div>
          </li>
          <li
            class="form-item"
            style="margin-bottom: 0px"
            v-if="
              curFormData.ocpx_action_type === 180 &&
              curFormData.deep_conversion_type !== 0
            "
          >
            <span class="form-label require" style="padding-top: 6px"
              >深度出价：</span
            >
            <div class="form-value">
              <el-form-item prop="deep_conversion_bid">
                <el-input
                  style="width: 264px"
                  v-model.trim="curFormData.deep_conversion_bid"
                >
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>
              <span
                v-if="curFormData.deep_conversion_bid"
                style="font-size: 14px; color: #666"
                >按两个出价计算得到期望的目标深度转化率为{{
                  curFormData.deep_conversion_bid &&
                  (curFormData.cpa_bid / curFormData.deep_conversion_bid) * 100
                    ? (
                        (curFormData.cpa_bid /
                          curFormData.deep_conversion_bid) *
                        100
                      ).toFixed(2)
                    : "-"
                }}%</span
              >
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 10px"
              >预算包名称：</span
            >
            <div class="form-value">
              <el-form-item prop="name">
                <el-input
                  style="width: 264px"
                  v-model="curFormData.name"
                ></el-input>
              </el-form-item>
            </div>
          </li>
        </el-form>
      </ul>
      <span slot="footer" class="footer-wrap">
        <el-button type="primary" @click="confirmForm">保存到预算包</el-button>
      </span>
    </div>

    <checked-modal
      title="选择预算包"
      :tableConf="tableConf"
      :tableData="tableData"
      ref="checkedModalRef"
      @selectOk="selectOk"
    ></checked-modal>
  </div>
</template>

<script>
import TimeTable from "@/components/timeTable.vue";
import CardItem from "./common/cardItem.vue";
import { mapState } from "vuex";
import CheckedModal from "./common/checkedModal.vue";
import { newBudget, getBudget } from "@/api/promotion-kuaishou.js";
import moment from "moment";
export default {
  components: {
    TimeTable,
    CardItem,
    CheckedModal,
  },
  data() {
    return {
      tableConf: [
        { title: "预算包名称", colName: "name" },
        { title: "创建时间", colName: "date" },
      ],
      tableData: [],
      dataList: [],
      curFormData: {},
      rules: {
        // roi_ratio: [
        //   {
        //     required: true,
        //     message: "ROI系数必填",
        //     trigger: ["blur"],
        //   },
        // ],
        cpa_bid: [
          {
            required: true,
            message: "请输入出价",
            trigger: ["blur"],
          },
        ],
        deep_conversion_bid: [
          {
            required: true,
            message: "请输入深度出价",
            trigger: ["blur"],
          },
        ],
        day_budget: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value === null || value === "") {
                callback(new Error("统一预算必填"));
              } else if (
                !/^[1-9]*[1-9][0-9]*$/.test(value) ||
                Number(value) < 100 ||
                Number(value) > 100000000
              ) {
                callback(new Error("请输入不小于100,不超过100000000的自然数"));
              } else {
                callback();
              }
            },
          },
        ],
        weekData: [
          {
            trigger: ["blur", "change"],
            type: "arr",
            validator: (rule, value, callback) => {
              for (let i = 0; i < value.length; i++) {
                let curItem = value[i];
                if (!curItem.value) {
                  callback(new Error("分日预算填写不完整"));
                  break;
                } else if (
                  !/^[1-9]*[1-9][0-9]*$/.test(curItem.value) ||
                  Number(curItem.value) < 100 ||
                  Number(value) > 100000000
                ) {
                  callback(
                    new Error("请输入不小于100,不超过100000000的自然数")
                  );
                  break;
                }
              }
              callback();
            },
          },
        ],
        name: [
          {
            required: true,
            message: `预算包名称必填`,
            trigger: ["blur"],
          },
        ],
      },
      pickerOptions: {
        disabledDate(current) {
          return current < moment().startOf("day");
        },
      },
    };
  },
  mounted() {
    this.newBudgetbid();
  },
  methods: {
    confirmForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          //保存分段日期数据
          this.saveCurDataRange(true);

          let copyData = JSON.parse(JSON.stringify(this.curFormData));
          this.formatData(copyData);
          newBudget({
            platType: 3,
            data: JSON.stringify(copyData),
          }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "预算包新建成功",
                type: "success",
              });
              // this.saveCurDataRange();
            }
          });
        } else {
          return false;
        }
      });
    },
    // checkBudgetMode(budget_mode) {
    //   this.curFormData.budget_mode = budget_mode;
    // },
    newBudgetbid() {
      if (this.dataList.length >= 10) {
        return;
      }
      let newItem = {
        itemId: Math.random(),
        name: "预算包" + (this.dataList.length + 1),
        schedule_type: "SCHEDULE_FROM_NOW",
        selectDate: [], //接口为start_time end_time
        budget_mode: "BUDGET_MODE_INFINITE",
        day_budget: "",
        weekData: [
          { lable: "星期一", value: "" },
          { lable: "星期二", value: "" },
          { lable: "星期三", value: "" },
          { lable: "星期四", value: "" },
          { lable: "星期五", value: "" },
          { lable: "星期六", value: "" },
          { lable: "星期日", value: "" },
        ],
        show_mode: 2,
        ocpx_action_type: 1,
        deep_conversion_type: 0,
        bid_type: 2,
        // roi_ratio: null,
        cpa_bid: null, //目标转化出价
        deep_conversion_bid: null, //深度出价

        schedule_time_type: "0", //投放时间段 0不限 1指定时间段
        schedule_time: "",
      };
      this.dataList.push(newItem);
      this.editBudget(newItem);
      this.saveListInStore();
    },
    selectBudgetBid() {
      this.$refs.checkedModalRef.showModal();
      //查询预算包
      getBudget({
        platType: 3,
      }).then((res) => {
        if (res.code === "0000") {
          this.tableData = res.budgetPrices.map((item) => {
            Object.assign(item, JSON.parse(item.data), {
              date: item.createDate,
            });
            return item;
          });
        }
      });
    },
    editBudget(dataItem) {
      //该数据不是接口格式！！！！！！
      this.saveCurDataRange();
      this.curFormData = dataItem;
      if (dataItem.schedule_time_type === "1") {
        let arr = dataItem.schedule_time.split("").map((item) => Number(item));
        let newArr = [];
        arr.forEach((item) => {
          if (item === 1) {
            newArr.push(1, 1);
          } else {
            newArr.push(0, 0);
          }
        });
        this.$refs.timeTableRef.showSelectNode(newArr);
      } else {
        this.$refs.timeTableRef && this.$refs.timeTableRef.clearSelect();
      }
    },
    copyBudget(dataItem) {
      if (this.dataList.length >= 10) {
        return;
      }
      let copyData = JSON.parse(JSON.stringify(dataItem));
      copyData.itemId = Math.random();
      copyData.name = copyData.name + "_复制";
      this.dataList.push(copyData);
      this.saveListInStore();
    },
    delBudget(dataItem) {
      let curIndex = this.dataList.findIndex(
        (item) => item.itemId === dataItem.itemId
      );
      this.dataList.splice(curIndex, 1);
      this.saveListInStore();
    },
    //格式化单条表单数据
    formatData(formData) {
      //投放时间
      if (formData.schedule_type === "SCHEDULE_START_END") {
        formData.begin_time = formData.selectDate[0];
        formData.end_time = formData.selectDate[1];
      } else {
        formData.begin_time = null;
      }
      delete formData.selectDate;

      //广告组预算
      if (formData.budget_mode === "BUDGET_MODE_DAY_SCHEDULE") {
        formData.weekData.forEach((item) => {
          item.value = item.value ? parseFloat(item.value) * 1000 : "0";
        });
        formData.day_budget_schedule = formData.weekData.map(
          (item) => item.value
        );
      }
      formData.day_budget = formData.day_budget
        ? parseFloat(formData.day_budget) * 1000
        : null;
      formData.cpa_bid = formData.cpa_bid
        ? parseFloat(formData.cpa_bid) * 1000
        : "0";
      //深度出价
      if (formData.deep_conversion_bid) {
        formData.deep_conversion_bid = formData.deep_conversion_bid
          ? parseFloat(formData.deep_conversion_bid) * 1000
          : null;
      }
    },
    transforApiToForm(item) {
      //投放时间
      if (item.schedule_type === "SCHEDULE_START_END") {
        item.selectDate = [item.begin_time, item.end_time];
      } else {
        item.selectDate = [];
      }
      //预算出价相关
      item.day_budget = item.day_budget ? item.day_budget / 1000 : 0;
      item.cpa_bid = item.cpa_bid ? item.cpa_bid / 1000 : 0;
      item.deep_conversion_bid = item.deep_conversion_bid
        ? item.deep_conversion_bid / 1000
        : null;
      item.weekData.forEach((wk) => {
        wk.value = wk.value ? wk.value / 1000 : "";
      });
    },
    saveCurDataRange(saveStatus) {
      //保存当前分段日期数据
      if (this.curFormData.schedule_time_type === "0") {
        let str = "1";
        for (let i = 0; i < 24 * 7 - 1; i++) {
          str += "1";
        }
        this.curFormData.schedule_time = str;
      } else {
        let newArr = [];
        let dataArr = this.$refs.timeTableRef.checkedValue;
        for (let i = 0; i < dataArr.length; i += 2) {
          if (dataArr[i] === 0 && dataArr[i + 1] === 0) {
            newArr.push(0);
          } else {
            newArr.push(1);
          }
        }
        this.curFormData.schedule_time = newArr.join("");
      }
      if (!saveStatus) {
        this.$refs.timeTableRef.clearSelect();
      }
    },
    saveListInStore() {
      //保存到store
      let storeDataList = JSON.parse(JSON.stringify(this.dataList));
      storeDataList.forEach((storeData) => {
        this.formatData(storeData);
      });
      this.$store.commit("set_budget_and_bid_k", storeDataList);
    },
    selectOk(data) {
      let dataList = data.map((item) => {
        let formData = JSON.parse(item.data);
        this.transforApiToForm(formData);
        return formData;
      });
      this.dataList.push(...dataList);
      //保存到store
      let storeDataList = JSON.parse(JSON.stringify(this.dataList));
      storeDataList.forEach((storeData) => {
        this.formatData(storeData);
      });
      this.$store.commit("set_budget_and_bid_k", storeDataList);
    },
    //保存模板时不校验，直接保存
    saveData() {
      this.saveCurDataRange(); //保存当前数据后再保存到store
      this.saveListInStore();
    },
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          let pass = true;
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i];
            if (
              item.cpa_bid == null ||
              // item.budget == null ||
              item.name == null
            ) {
              pass = false;
              this.editBudget(item);
              this.$nextTick(() => {
                this.$refs.formRef.validate(() => {});
              });
              break;
            }
          }
          if (pass) {
            this.saveData();
            resolve();
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },
    renderRule() {
      this.$refs.formRef.validate();
    },
    //切换优化目标
    changeActionType(val) {
      if (val === 1) {
        //封面点击数
        this.curFormData.bid_type = 2;
      } else {
        this.curFormData.bid_type = 10;
      }
    },
  },
  computed: {
    ...mapState({
      //是否展示深度相关表单
      // showDeep: (state) => {
      //   let pro_obj = state.PromotionKuaishou.draft_adset.promote_object;
      //   return pro_obj &&
      //     pro_obj.deep_external_action === "AD_CONVERT_TYPE_NEXT_DAY_OPEN"
      //     ? true
      //     : false;
      // },
      budget_and_bid: (state) =>
        state.PromotionKuaishou.draft_adset.budget_and_bid,
    }),
  },
  watch: {
    budget_and_bid(value) {
      if (value) {
        let copyList = JSON.parse(JSON.stringify(value));
        //还原表格数据
        copyList.forEach((item) => {
          this.transforApiToForm(item);
        });
        this.dataList = copyList;
        if (this.dataList.length > 0) {
          //聚焦最后一个
          this.editBudget(this.dataList[this.dataList.length - 1]);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.budget-bid-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .modal-body {
    padding-top: 10px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 100px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          &.require::before {
            content: "*";
            color: red;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          // .down-wrap {
          //   cursor: pointer;
          // }
          .data-range {
            margin-top: 10px;
            position: relative;
            /deep/.el-range__icon {
              position: absolute;
              right: 6px;
              top: 0px;
            }
            /deep/.el-range-separator {
              line-height: 24px;
              color: rgba(0, 0, 0, 0.25);
            }
          }
          .time-range-wrap {
            margin-top: 10px;
            border: 1px solid #eee;
            padding-bottom: 14px;
          }
          .week-wrap {
            padding: 0px;
            margin: 0px;
            list-style: none;
            border: 1px solid rgb(238, 238, 238);
            display: flex;
            width: 616px;
            height: 68px;
            .week-item {
              display: inline-block;
              width: 88px;
              border-right: 1px solid rgb(238, 238, 238);
              .week-label {
                height: 32px;
                line-height: 32px;
                text-align: center;
                font-size: 12px;
                background-color: #f7f7f7;
              }
              .week-value {
                height: 32px;
                .week-input {
                  width: 100%;
                  height: 100%;
                  box-sizing: border-box;
                  outline: none;
                  text-align: center;
                  border: none;
                }
              }
            }
            .week-item:last-child {
              border-right: none;
            }
          }
        }
      }
    }
    .footer-wrap {
      display: block;
      text-align: right;
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
}
</style>